<template>
  <div id="globalNewParams" class="warp">
    <!-- 头部搜索栏 -->
    <div>
      <div class="button" style="margin-bottom: 20px">
        <el-button type="success" size="mini" @click="getList">刷新</el-button>
        <el-button
          type="primary"
          size="mini"
          class="edit-button"
          @click="getList"
        >筛选</el-button>
        <el-button
          type="warning"
          size="mini"
          @click="resetEvent()"
        >重置</el-button>
      </div>
      <div class="head_search">
        <div class="item_warp">
          <label style="width: 54px">手机号</label>
          <el-input
            v-model="phone"
            placeholder="请输入手机号"
            style="width: 150px"
            size="mini"
            clearable
          />
        </div>
        <div class="item_warp">
          <label style="width: 44px">姓名</label>
          <el-input
            v-model="userName"
            placeholder="请输入姓名"
            style="width: 150px"
            size="mini"
            clearable
          />
        </div>
      </div>
    </div>
    <!-- 表单 -->
    <div class="table_warp">
      <el-table
        ref="gridTable"
        v-loading="loading"
        :data="userTable"
        border
        style="width: 1711px"
        height="calc(100vh - 320px )"
        size="mini"
      >
        <!-- <el-table-column type="selection" width="50" /> -->
        <!-- 备注 -->
        <el-table-column prop="id" label="id" width="100" />
        <el-table-column prop="avatar" label="头像" width="100">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.avatar"
              :src="scope.row.avatar"
              fit="contain"
              style="width: 40px; height: 40px"
              :preview-src-list="toArrayEvent(scope.row.avatar)"
            />
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="手机号" width="140" />
        <el-table-column prop="userName" label="姓名" width="100" />
        <el-table-column prop="sex" label="性别" width="100">
          <template slot-scope="scope">
            {{ sexOp[scope.row.sex] }}
          </template>
        </el-table-column>
        <el-table-column prop="birthDate" label="出生年月" width="100" />
        <el-table-column prop="isVip" label="绑定会员" width="100" />
        <el-table-column prop="vipId" label="会员ID" width="100" />
        <el-table-column prop="unionid" label="unionid" width="270" />
        <el-table-column prop="openid" label="openid" width="270" />
        <!-- 创建时间-->
        <el-table-column prop="createdAt" label="创建时间" width="200">
          <template slot-scope="scope">
            {{
              $parseTime(
                new Date(scope.row.createdAt),
                "{y}-{m}-{d} {h}:{i}:{s}"
              )
            }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              icon="el-icon-edit"
              @click="editEvent(scope.row)"
            >编辑</el-button>
            <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              @click="removeVipEvent(scope.row)"
            >解绑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="pageNumber"
      :limit.sync="pageSize"
      :page-sizes="[2, 5, 10, 20, 50]"
      @pagination="next()"
    />

    <!-- 添加弹窗 -->
    <el-dialog
      title="编辑会员信息"
      :visible.sync="dialogVisible"
      width="900px"
      :close="handleClose"
      :close-on-click-modal="false"
      :center="true"
      style="height: 90vh; margin-top: 40px"
    >
      <el-form ref="form" :model="formData" label-width="220px" size="mini">
        <el-form-item label="手机号">
          <el-input
            v-model="formData.phone"
            placeholder="请输入手机号"
            style="width: 300px"
            size="mini"
            clearable
          />
        </el-form-item>
        <el-form-item label="姓名">
          <el-input
            v-model="formData.userName"
            placeholder="请输入姓名"
            style="width: 300px"
            size="mini"
            clearable
          />
        </el-form-item>
        <el-form-item label="性别">
          <el-radio v-model="formData.sex" label="0">女</el-radio>
          <el-radio v-model="formData.sex" label="1">男</el-radio>
        </el-form-item>
        <el-form-item label="出生年月">
          <el-date-picker
            v-model="formData.birthDate"
            type="date"
            placeholder="请选择出生年月"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          style="margin-right: 10px"
          @click="dialogVisible = false"
        >关闭</el-button>
        <el-popconfirm title="确定添加？" @onConfirm="submitEvent()">
          <el-button
            slot="reference"
            type="primary"
            class="edit-button"
          >保存</el-button>
        </el-popconfirm>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from '@/components/Pagination' // 引入分页器
import uploadPic from '@/components/Upload/UploadPic' // 引入单图片上传组件
import environment from '@/utils/environment'
import { wxUserManagerList, updateWxUser, unbindVip } from '@/api/user'
export default {
  name: 'GlobalNewParams',
  components: { Pagination },
  data() {
    return {
      pageNumber: 1,
      pageSize: 20,
      total: 0,
      userTable: [],
      phone: '',
      userName: '',
      loading: false,
      sexOp: ['女', '男'],
      dialogVisible: false,
      formData: {
        userName: '',
        phone: '',
        sex: 0,
        birthDate: ''
      }
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    toArrayEvent(item) {
      return [item]
    },
    // 获取列表数据
    getList() {
      this.loading = true
      var params = {
        pageNum: this.pageNumber,
        pageSize: this.pageSize,
        phone: this.phone,
        userName: this.userName
      }
      wxUserManagerList(params)
        .then((res) => {
          console.log(res)
          this.userTable = res.rows
          this.total = res.count
        })
        .catch((err) => {
          this.$message.error(err || '服务器错误，请稍后重试')
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 下一页或刷新
    next() {
      this.$refs.gridTable.bodyWrapper.scrollTop = 0
      this.getList()
    },
    select() {
      this.pageNumber = 1
      this.getList()
    },
    resetEvent() {
      this.userName = ''
      this.phone = ''
      this.getList()
    },
    // 关闭添加弹窗
    handleClose() {
      this.initForm()
    },
    initForm() {
      this.formData = {}
    },
    editEvent(data) {
      this.dialogVisible = true
      this.formData = { ...this.formData, ...data }
    },
    submitEvent() {
      updateWxUser(this.formData)
        .then((res) => {
          this.$message.success('修改成功')
          this.dialogVisible = false
          this.getList()
        })
        .catch((error) => {
          this.$message.error(error || '修改失败')
        })
    },
    // 解绑会员
    removeVipEvent(data) {
      console.log(data, 'data.....')
      this.$confirm('是否确定解绑会员?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          console.log('data', data)
          unbindVip({ unionid: data.unionid, phone: data.phone })
            .then((res) => {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getList()
            })
            .catch((error) => {
              this.$message({
                type: 'warning',
                message: error || '删除失败!'
              })
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消解绑'
          })
        })
    }
  }
}
</script>
<style lang="scss" scoped>
#globalNewParams {
  .el-image {
    position: relative;
    display: inline-block;
    overflow: hidden;
    width: 100px;
    height: 100px;
  }

  .head_search {
    display: flex;
    width: 100%;
    margin-bottom: 20px;

    .item_warp {
      display: flex;

      .el-checkbox {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 10px;
      }

      label {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #525252;
        font-weight: 400;
      }
    }
  }

  .green {
    color: #00c759;
  }

  .red {
    color: rgb(255, 62, 51);
  }

  .el-tag + .el-tag {
    margin-left: 3px;
  }

  .button-new-tag {
    margin-left: 10px;
    margin-top: 5px;
    height: 25px;
    line-height: 25px;
    padding-top: 0;
    padding-bottom: 0;
  }

  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }

  .zhi {
    margin: 0 0 10px 0;
    display: flex;
    align-items: center;
  }

  .el-tag--mini {
    height: 20px;
    padding: 0px 5px;
    line-height: 19px;
    margin: 0px 0 2px 0;
  }
  .set-tag {
    cursor: pointer;
    background: rgba(236, 236, 255, 1);
    // border: 1px solid rgba(236, 236, 255, 1) ;
    color: #6663ff;
    font-weight: bold;
  }
}
</style>
